import Vue from 'vue';
import Vuex from 'vuex';
import { IRootState } from '@/interfaces';

Vue.use(Vuex);

import { userStore } from './user';
import { cartStore } from './cart';

export default new Vuex.Store<IRootState>({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    userStore, cartStore
  }
});
